import {ElmFrameworkPorts} from "../../ElmFrameworkPorts";

export {
  handleClipboard,
}

function handleClipboard(appPorts: ElmFrameworkPorts) {
  appPorts.copyToClipboard?.subscribe(text => {
    navigator.clipboard.writeText(text);
  });
}

